import * as z from 'zod';

export const LoginFormSchema = z.object({
  email: z.string().nonempty('Email is required').email(),
  password: z.string().nonempty('Password is required'),
});

export type LoginFormSchemaPayload = z.infer<typeof LoginFormSchema>;
